define('gigaset_recurring/classes/provider/billwerk/steps/shipping-address',[
	"jquery",
	"lodash",
	"./address/_abstract",
	"cartware/jquery/bem",
	"cartware/components/Registry",
	"cartware/components/Logger",
	"jquery-serialize-object"
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Registry,
	Logger
) {

	function AddressStep() {
		AbstractStep.call(this);
		this.logger = Logger.getLogger("gigaset_recurring.shipping_address");
		this.rootElement = $('#step-shipping-address');
	}

	AddressStep.prototype = _.create(new AbstractStep, {
		constructor: AddressStep,
		formDataKey: "shipping-address"
	});

	return AddressStep;

});
